import {
  Component,
  Input,
  ViewChild,
  ViewContainerRef,
  TemplateRef,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  ListItemModel
} from '../list/state/items/item.model';

import { getData } from '../list/helpers';


export class SkyGridCellComponent implements OnInit {
  
  public item: ListItemModel;

  
  public columnId: string;

  
  private template: TemplateRef<any>;

  
  private fieldSelector: string;

  
  private container: ViewContainerRef;

  public ngOnInit() {
    this.container.createEmbeddedView(this.template, this);
  }

  get row() {
    return this.item.data;
  }

  get value() {
    if (this.item.data && (this.fieldSelector || this.columnId)) {
      return getData(this.item.data, this.fieldSelector || this.columnId);
    }

    return undefined;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-grid-cell',
  template: '<ng-template #cell></ng-template>',
  styles: [`:host {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 8px;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'item': [{ type: Input },],
'columnId': [{ type: Input },],
'template': [{ type: Input },],
'fieldSelector': [{ type: Input },],
'container': [{ type: ViewChild, args: ['cell', { read: ViewContainerRef }, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
